var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.679 11.0337C13.4627 11.0337 11.6778 12.8192 11.6778 15.038C11.6778 16.1446 12.1181 17.1269 12.8466 17.8542L13.4204 18.427L12.2748 19.5747L11.7009 19.0018C10.6805 17.9831 10.0562 16.5929 10.0562 15.038C10.0562 11.9246 12.5661 9.41211 15.679 9.41211C17.2174 9.41211 18.6385 10.0349 19.6484 11.0609L20.2171 11.6388L19.0615 12.7763L18.4927 12.1985C17.784 11.4785 16.7778 11.0337 15.679 11.0337Z",
  fill: "#282828"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.3431 15.2367L21.1996 16.0347C20.7869 18.3295 18.9815 20.1387 16.688 20.555L15.8902 20.6999L15.6006 19.1043L16.3984 18.9595C18.0256 18.6641 19.3106 17.3768 19.6036 15.7477L19.7471 14.9497L21.3431 15.2367Z",
  fill: "#282828"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.8921 5.77763C13.5128 5.77763 11.1932 6.66145 9.15596 8.33143L9.15403 8.333C7.16802 9.95076 5.44505 12.3093 4.15688 15.2844C5.40969 18.2199 6.74389 20.0959 8.70916 21.694L9.33824 22.2056L8.31514 23.4637L7.68607 22.9522C5.39129 21.0861 3.89291 18.8874 2.5276 15.5932C2.445 15.3939 2.44523 15.1699 2.52825 14.9708C3.91072 11.6545 5.82787 8.95117 8.12897 7.07645C10.4203 5.19861 13.0947 4.15601 15.8921 4.15601C18.6508 4.15601 21.0227 4.8051 23.369 6.72998L23.9958 7.24425L22.9673 8.49794L22.3404 7.98367C20.3306 6.33477 18.3405 5.77763 15.8921 5.77763Z",
  fill: "#282828"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.0674 4.7951L5.5739 26.2885L4.42725 25.1418L25.9207 3.64844L27.0674 4.7951Z",
  fill: "#282828"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.9349 8.2644L23.7159 9.49774C25.0848 10.9382 26.3092 12.778 27.3072 15C24.5741 21.085 20.1438 24.3035 15.6946 24.305C13.9405 24.3044 12.1893 23.8038 10.5439 22.8246L9.29004 24.0932C10.7564 25.0318 12.3292 25.6481 13.9612 25.9049C14.5315 25.9945 15.109 26.0403 15.6917 26.0406H15.6946H15.6975C16.2802 26.0403 16.8577 25.9945 17.428 25.9049C22.2955 25.1392 26.636 21.175 29.1975 15C28.0804 12.3071 26.6249 10.0345 24.9349 8.2644Z",
  fill: "#282828"
});

function SvgDismiss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDismiss);
export default __webpack_public_path__ + "static/media/Dismiss.f9e01c75.svg";
export { ForwardRef as ReactComponent };